import { pxArrayToRem, pxToRem } from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';

export const VariantPricing: StyleRule = ({ theme }) => ({
    color: theme.siteVariables.colors.charcoal[250],
    ...theme.siteVariables.textStyles.Heading.Roman55,
    fontSize: pxToRem(22),
    lineHeight: pxToRem(22),
    fontWeight: 400,
    padding: 0,
    position: 'relative',
    right: 0,
    display: 'grid',
    rowGap: pxToRem(12),
});

export const PricePrefix: StyleRule = ({ theme }) => ({
    fontSize: pxToRem(16),
    color: theme.siteVariables.colors.grey[300],
    letterSpacing: theme.siteVariables.letterSpacingMedium,
    lineHeight: theme.siteVariables.lineHeightDefault,
});

export const RetailPrice: StyleRule = ({ theme }) => ({
    fontSize: pxToRem(22),
    color: '#969696', // Not in the color palette
    letterSpacing: theme.siteVariables.letterSpacingMedium,
    lineHeight: theme.siteVariables.lineHeightDefault,
    ...theme.siteVariables.textStyles.Text.Roman55,
});

export const PriceGroup: StyleRule = ({ theme }) => ({
    display: 'grid',
    gridAutoFlow: 'row',
    gap: pxArrayToRem([5, 11]),
    alignItems: 'center',
    gridTemplateColumns: 'auto 1fr',

    [`& a`]: {
        textDecoration: 'underline',
        color: theme.siteVariables.colorScheme.default?.foreground,
    },
});

export const Price: StyleRule = ({ theme }) => ({
    fontSize: pxToRem(22),
    wordSpacing: pxToRem(6),
    letterSpacing: theme.siteVariables.letterSpacingSmall,
});

export const MaxPriceHyphen: StyleRule = () => ({
    margin: pxArrayToRem([0, 11, 0, 11]),
});

export const PricePOA: StyleRule = ({ theme }) => ({
    letterSpacing: theme.siteVariables.letterSpacingSmall,
    fontSize: pxToRem(16),
    lineHeight: '130%',
    textUnderlineOffset: pxToRem(3),
    textDecoration: 'underline',
    cursor: 'pointer',
});

export const Subtitle: StyleRule = ({ theme, isPriceRange }) => ({
    ...theme.siteVariables.textStyles.Text.Roman55,
    gridColumn: isPriceRange ? 2 : 1,
    color: theme.siteVariables.colors.grey[300],
    fontSize: pxToRem(16),
    lineHeight: 1,
});
